<template>
  <div>
    <div class="dataTable" style="margin-top: 0">
      <div class="rightAll-btn">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item :label="$t('common.num')">
            <el-select
              v-model="formInline.numberType"
              style="width: 120px"
              :placeholder="$t('common.form.choseTip')"
              class="selectStyle"
            >
              <el-option
                v-for="item in optionsInput"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-input
              size="mini"
              v-model="formInline.number"
              :placeholder="$t('common.searchTip')"
              style="width: 150px"
              class="inputStyle"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              size="mini"
              type="primary"
              @click="onSearch"
              class="btn-chaxun"
              >{{$t('common.btn.search')}}</el-button
            >
            <el-button size="mini" @click="onClear" class="btn-del"
              >{{$t('common.btn.cancel')}}</el-button
        >
          </el-form-item>
        </el-form>
        <el-button v-if="isPrimaryKey('CHECKREPORTFORM_MONTH_DOWN')" type="text" @click="downCar">{{$t('common.btn.download')}}</el-button>
      </div>
      <i-table
        :list="list"
        ref="carTable"
        @handleSelectionChange="handleSelectionChange"
        :options="option"
        :columns="columns"
        :operates="operates"
      ></i-table>
      <IPagination ref="page" @PageFun="changeSize"></IPagination>
    </div>
  </div>
</template>

<script>
import MonthTime from "./MonthTime";
export default MonthTime;
</script>

<style lang="less" scoped>
@import "../../../../../assets/styles/Style.less";
</style>
